import FuseLoadable from '@fuse/components/FuseLoadable/FuseLoadable'

export const ContabilitaConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: '/contabilita/:contabilita/add',
      component: FuseLoadable({
        loader: () => import('./AddContabilita')
      })
    },
    {
      path: '/contabilita/controllo-fatture',
      component: FuseLoadable({
        loader: () => import('./ControlloFatture')
      })
    },
    {
      path: '/contabilita/:contabilita',
      component: FuseLoadable({
        loader: () => import('./Contabilita')
      })
    },
    {
      path: '/stipendi',
      component: FuseLoadable({
        loader: () => import('./Stipendi')
      })
    },
    {
      path: '/percentuali_stipendi',
      component: FuseLoadable({
        loader: () => import('./PercentualiStipendi')
      })
    }
  ]
}
